/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */
import { Joomla } from './blackmostros.joomla.js';
import {
  when_available,
  console_if_debug,
  } from './blackmostros.method.js';
import { BlackMostrosMobileButton } from './blackmostros.mobile.js';

// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(BlackMostrosMenu(obj));
//     reject('bad');
//     });
//   };


let BlackMostrosMenu = (function(
  $
  // _q
  ){
  /*
   * Menu have two states:
   *  0 - desktop menu
   *  1 - mobile menu
   *
   */
  var _state,
    _mbutton,
    _mbuttonres,
    _showinres,
    displayed = false,
    _topmenu,
    _menuid,
    $menu,
    $menuWrapper,
    $treemenu,
    $islevel1,
    _menu_open_event0,
    _menu_close_event0,
    _menu_open_event,
    _menu_close_event,
    _win=window,
    _sel = {
      menu: ".dropdown.level-1",
      submenu: 'ul.tree',
      treemenu: 'div.ui_icon',
      // ~ treemenu: 'span.glyphicon',
      header_group: ".header-group",
      label_toggle: "label.tree-toggler",
      close_icon_class: 'i_minus',
      // ~ _close_icon_class="close",
      open_icon_class: 'i_plus',
      // ~ _open_icon_class="open",
      hide_class: 'hidden',
      // ~ _hide_class='hidden',
      },
    mpublic = {};

  function _set_menu_state(){
    // set menu state seen screen size
  }

  function _resize_handler(){
    // get current window width
    var _w = _win.innerWidth,
      _h = _win.innerHeight;
    /*
    var _w = $(window).width(),
      _h = $(window).height();
    */

    // better use window.getSize

    // hide or show mobile button
    _mbutton.hide_or_show(_w);
  }

  function _set_events(){
    // set menu events
    _menu_open_event0 = new Event("menu-opened-0");
    _menu_close_event0 = new Event("menu-closed-0");
    _menu_open_event = new Event("menu-opened");
    _menu_close_event = new Event("menu-closed");

    /*
    _menu_open_event0 = $.Event("menu-opened-0");
    _menu_close_event0 = $.Event("menu-closed-0");
    _menu_open_event = $.Event("menu-opened");
    _menu_close_event = $.Event("menu-closed");
    */
  }

  /*
   * menu tree hide/show
   *
   */
  // menu tree
  // if screen resolution > _showinres fix topmenuwrap when show submenu
  function hide_show_treemenu(){
    // try get tree menu clicked, if undefined,
    // try get some dropdown tree element opened in level-1
    var _button = this;
    // ~ console.log('hide_show_treemenu', _button);

    /*
    function _old_method(){
      $islevel1 = $(this).parent().parent();
      var levclass = $islevel1.attr('class');
      if (levclass) {
        $(this).parent().parent().children('ul.tree').toggle();
        $treemenu = $(this).children('span.glyphicon');
        $treemenu.toggleClass("glyphicon-minus");
        // dont fix menu here better hix header
        //mpublic.fixmenu($islevel1, $treemenu, 0);
        if ($treemenu.hasClass("glyphicon-minus")) {
          if ($islevel1.hasClass("level-1")){
            _topmenu.trigger(_menu_open_event0);
          } else {
            _topmenu.trigger(_menu_open_event);
          }
        } else {
          if ($islevel1.hasClass("level-1")){
            _topmenu.trigger(_menu_close_event0);
          } else {
            _topmenu.trigger(_menu_close_event);
          }
        }
      } else {
        var _mnu = _topmenu.find(".dropdown.level-1");
        $treemenu = _mnu.children(".header-group")
          .children("label.tree-toggler")
          .children("span");
        $islevel1 = _mnu.attr("class");
        if ($treemenu.hasClass("glyphicon-minus")) {
          _mnu.children('ul.tree').toggle();
          $treemenu.toggleClass("glyphicon-minus");
          _topmenu.trigger(_menu_close_event0);
          //~ mpublic.fixmenu($islevel1, $treemenu, 0);
        } else {
          _topmenu.trigger(_menu_open_event0);
        }
        //~ mpublic.fixmenu($islevel1, $treemenu, 0);
      }
    }
    */

    function _new_method(){
      // ~ console.log(_button);
      let $parent = _button.parentElement.parentElement,
        $submenu = $parent.querySelector(_sel.submenu),
        $treemenu = $parent.querySelector(_sel.treemenu);

      // set treemenu icon
      if ($treemenu.classList.contains(
        _sel.close_icon_class
        // ~ _close_icon_class
        )) {
        $treemenu.classList.replace(
          _sel.close_icon_class,
          _sel.open_icon_class
          // ~ _close_icon_class,
          // ~ _open_icon_class
          );

        // $submenu.classList.remove(
        //   _sel.hide_class
        //   // ~ _hide_class
        //   );

      } else {
        $treemenu.classList.replace(
          _sel.open_icon_class,
          _sel.close_icon_class
          // ~ _open_icon_class,
          // ~ _close_icon_class
          );

      }

      // show hide submenu
      $submenu.classList.toggle(
        _sel.hide_class
        // ~ _hide_class
        );

      // trigger menu event in level-1
      if ($parent.classList.contains("level-1")){
        _topmenu.dispatchEvent(_menu_open_event0);
        // ~ _topmenu.trigger(_menu_open_event0);
      } else {
        _topmenu.dispatchEvent(_menu_open_event);
        // ~ _topmenu.trigger(_menu_open_event);
      }

      // ~ console.log($parent, $submenu, $treemenu);
    }
    _new_method();
  }

  function _hide_mobile_menu(){
    /*
     * hide all menu only if in mobile screens
     *
     */
    //~ if (_w < _showinres) {
    _mbutton.hide_menu();
    //~ }
  }
  mpublic.hide_mobile_menu = _hide_mobile_menu;

  function _hide_menu(){
    /*
     * only hide level-1 elements if in desktop screens
     * else hide mobile menu
     *
     */
    var _mnu = _topmenu.querySelector(_sel.menu);
    // ~ var _mnu = _topmenu.find(".dropdown.level-1");

    $treemenu = _mnu
      .querySelector(
        _sel.header_group
        // ~ ".header-group"
        )
      .querySelector(
        _sel.label_toggle
        // ~ "label.tree-toggler"
        )
      .querySelector(
        _sel.treemenu
        // ~ "span"
        );

    // $treemenu = _mnu.children(".header-group")
    //   .children("label.tree-toggler")
    //   .children("span");

    // ~ $islevel1 = _mnu.attr("class");
    // ~ if ($treemenu.hasClass("glyphicon-minus")) {
    if ($treemenu.classList.contains(
      _sel.open_icon_class
      // ~ _open_icon_class
      )) {
      _mnu.querySelector(
        _sel.submenu
        // ~ 'ul.tree'
        ).classList.add(
          _sel.hide_class
          // ~ _hide_class
          );

      $treemenu.classList.replace(
        _sel.close_icon_class,
        _sel.open_icon_class,
        // ~ _close_icon_class,
        // ~ _open_icon_class
        );

      // _mnu.children('ul.tree').toggle();
      // $treemenu.toggleClass("glyphicon-minus");
      // //~ mpublic.fixmenu($islevel1, $treemenu, 0);
    }
    //~ mpublic.fixmenu($islevel1, $treemenu, 0);

    // dont call next method recursion error
    // hide_show_treemenu();
  }
  mpublic.hide_menu = _hide_menu;

  function _init(menuid, mbuttonres){
    _menuid = menuid;
    _mbuttonres = mbuttonres;
    // ~ console.log('here...');

    // ~ console.log('Waiting for joomla...');
    // set mobile button
    function _joomla_method(j){

      //~ $(Joomla).ready(function(){
      // ~ console.log('menu init', $menuWrapper);
      _mbutton = new BlackMostrosMobileButton($);
      _mbutton.init($menu, $menuWrapper, _mbuttonres);

      // call to resize handler to show or hide elements
      _resize_handler();

      // react on resize events
      _win.addEventListener('resize', _resize_handler);
      // ~ $(window).on('resize', _resize_handler);

      // menu tree click
      // if screen resolution > _showinres fix topmenuwrap when show submenu
      [].forEach.call(
        $menu.querySelectorAll(
          _sel.label_toggle
          // ~ 'label.tree-toggler'
          ),
        function (e, i) {
          e.addEventListener('click', hide_show_treemenu)
          }
        );
      // ~ $('label.tree-toggler').click(hide_show_treemenu);
    }

    /*
     * search top menu in dom
     * if not found, do nothing
     */
    // set top menu
    _topmenu = $.getElementById(_menuid);
    if (_topmenu) {
      // ad event emitter properties
      // ~ extend(_topmenu , EventEmitter);
      function _hide() {
        _topmenu.classList.add(
          _sel.hide_class
          // ~ _hide_class
          );
      }
      _topmenu.hide = _hide;

      function _show() {
        _topmenu.classList.remove(
          _sel.hide_class
          // ~ _hide_class
          );
      }
      _topmenu.show = _show;
      // ~ _topmenu = $(_menuid);

      // set menu events
      _set_events();

      // set menu parts

      $menu = _topmenu.querySelector('ul.menu');
      $menuWrapper = _topmenu;
      /*
      $menu = _topmenu.find('ul.menu').first();
      $menuWrapper = _q('<div>', {id : 'menuwrapper', role: 'menubar'});
      */

      // ~ _set_menu_state();
      when_available('Joomla', _joomla_method);

      console_if_debug('Blackmostros menu ready...');
      // ~ console.log('Blackmostros menu ready...');
    } else {
      console_if_debug('Blackmostros menu not found...');
      // ~ console.log('Blackmostros menu not found...');
    }

  }
  mpublic.init = _init;

  return mpublic;

});

export {
  BlackMostrosMenu,
  };
